module.exports = __webpack_public_path__ + "img/album21_20.3ed52611.jpg";